import { Serializable } from '../../common/serializable.interface'
import { FlightNetworkCenterEmailAddress } from '../../@store/reducers/flight-network.reducer'

export class CenterEmailAddress extends Serializable<CenterEmailAddress> implements FlightNetworkCenterEmailAddress {
  id: number | null = null
  email_address = ''

  constructor(details: Partial<CenterEmailAddress>) {
    super()
    this.checkAndDeserialize(details)
  }

  public get isNotEmpty(): boolean {
    return this.email_address.trim() !== ''
  }

  deserialize(details: Partial<CenterEmailAddress>): void {
    this.id = details.id ?? null
    this.email_address = details.email_address ?? ''
  }

  toJSON(): FlightNetworkCenterEmailAddress {
    return {
      // don't add null id's to the JSON
      ...(this.id && { id: this.id }),
      email_address: this.email_address,
    }
  }
}
